import React from 'react';
import Whychooseimg03 from '../../assets/images/services/service2.png';
import SecurityImg from '../../assets/images/services/service1.png';
import RealEstateImg from '../../assets/images/services/service3.png';
import TaxationImg from '../../assets/images/services/service7.png';
// import ImmigrationImg from '../../assets/images/services/service6.png';
import EventsImg from '../../assets/images/services/service8.png';
import DocumentationImg from '../../assets/images/services/service9.png';
import MedicalImg from '../../assets/images/services/service4.png';
import LegalImg from '../../assets/images/services/service5.png';

const MainServices = () => {
  return (
    <>
      <div className="py-5" style={{ background: '#fff' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 mb-4 mb-lg-0 ">
              <div className="mb-3">
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  background: '#fff',
                  border: '1.5px solid #bfc8d6',
                  borderRadius: '2em',
                  padding: '0.25em 1.2em 0.25em 0.9em',
                  fontSize: '0.7rem',
                  fontWeight: 500,
                  letterSpacing: '0.15em',
                  color: '#222',
                  marginBottom: '0.5em',
                  gap: '0.2em',
                  marginLeft:"1rem",
                }}>
                  <span role="img" aria-label="Finance" style={{ fontSize: '0.8rem' }}>🤝</span>
                  FINANCE & ACCOUNTANCY
                </span>
              </div>
              <h1 className="fw-bold mb-2" style={{ fontSize: '1.6rem', lineHeight: 1.13, color: '#111', marginLeft: "1rem" }}>
                Managing your finances across borders.
              </h1>
              <h3 className="fw-semibold mb-3" style={{ color: '#555', fontSize: '1.1rem', lineHeight: 1.2, marginLeft: "1rem" }}>
                Made easy and stress-free.
              </h3>
              <p className="text-muted" style={{ maxWidth: '650px', fontSize: '0.9rem', lineHeight: 1.7, marginTop: "10px", marginLeft:"1rem", }}>
                At NRI Advisors, we help you stay in control of your accounts, investments, and compliance – no matter where you are in the world. Our experienced team handles everything from account setup to financial reporting with precision and care, so you can focus on your goals, not paperwork. We keep it simple, transparent, and tailored to your needs – always with integrity at the heart of what we do.
              </p>
            </div>
            <div className="col-lg-5 d-flex justify-content-center">
              <img
                src={Whychooseimg03}
                alt="Finance meeting"
                className="img-fluid rounded"
                style={{ maxWidth: '80%', height: 'auto', objectFit: 'cover', boxShadow: '0 2px 24px rgba(0,0,0,0.04)' }}
              />
            </div>
          </div>
        </div>
      </div>


       {/* Taxation Section */}
      <div className="py-5" style={{ background: '#f2f4f8' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 d-flex justify-content-center mb-4 mb-lg-0">
              <img
                src={TaxationImg}
                alt="Taxation book and gavel"
                className="img-fluid rounded"
                style={{ maxWidth: '80%', height: 'auto', objectFit: 'cover', boxShadow: '0 2px 24px rgba(0,0,0,0.04)' }}
              />
            </div>
            <div className="col-lg-7">
              <div className="mb-3">
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  background: '#fff',
                  border: '1.5px solid #bfc8d6',
                  borderRadius: '2em',
                  padding: '0.25em 1.2em 0.25em 0.9em',
                  fontSize: '0.7rem',
                  fontWeight: 500,
                  letterSpacing: '0.15em',
                  color: '#222',
                  marginBottom: '0.5em',
                  gap: '0.2em',
                  marginLeft:"1rem",
                }}>
                  <span role="img" aria-label="Taxation" style={{ fontSize: '0.8rem' }}>🤝</span>
                  TAXATION
                </span>
              </div>
              <h1 className="fw-bold mb-2" style={{ fontSize: '1.5rem', lineHeight: 1.13, color: '#111', marginLeft:"1rem", }}>
                Cross-border taxes may be complicated.
              </h1>
              <h3 className="fw-semibold mb-3" style={{ color: '#555', fontSize: '1.1rem', lineHeight: 1.2, marginLeft:"1rem", }}>
                Yours needn’t be.
              </h3>
              <p className="text-muted" style={{ maxWidth: '650px', fontSize: '0.9rem', lineHeight: 1.7, marginTop: "10px", marginLeft:"1rem", }}>
                Our tax experts specialize in helping NRIs navigate multiple jurisdictions with clarity and ease. Whether you’re managing income, assets, or filings in more than one country, we’ll help you stay compliant and smart about your money. No jargon. No headaches. Just solid, proactive tax guidance you can count on.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Real Estate Section */}
      <div className="py-5" style={{ background: '#fff' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 mb-4 mb-lg-0 ">
              <div className="mb-3">
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  background: '#fff',
                  border: '1.5px solid #bfc8d6',
                  borderRadius: '2em',
                  padding: '0.25em 1.2em 0.25em 0.9em',
                  fontSize: '0.7rem',
                  fontWeight: 500,
                  letterSpacing: '0.15em',
                  color: '#222',
                  marginBottom: '0.5em',
                  gap: '0.2em',
                  marginLeft:"1rem",
                }}>
                  <span role="img" aria-label="Real Estate" style={{ fontSize: '0.8em', marginLeft:"1rem", }}>🤝</span>
                  REAL ESTATE MANAGEMENT
                </span>
              </div>
              <h1 className="fw-bold mb-2" style={{ fontSize: '1.5rem', lineHeight: 1.13, color: '#111', marginLeft:"1rem", }}>
                Seamless property solutions.
              </h1>
              <h3 className="fw-semibold mb-3" style={{ color: '#555', fontSize: '1.1rem', lineHeight: 1.2,  marginLeft:"1rem",  }}>
                For NRIs anywhere.
              </h3>
              <p className="text-muted" style={{ maxWidth: '650px', fontSize: '0.9rem', lineHeight: 1.7, marginTop: "10px", marginLeft:"1rem", }}>
                From buying, selling, and renting to investment support and title transfers – we take care of every step with honesty, speed, and clear communication. You won't have to chase agents, worry about maintenance, or stress about paperwork. We’ve got your back – like a reliable friend on the ground. Your property, our priority. Always.
              </p>
            </div>
            <div className="col-lg-5 d-flex justify-content-center">
              <img
                src={RealEstateImg}
                alt="Real estate handshake"
                className="img-fluid rounded"
                style={{ maxWidth: '80%', height: 'auto', objectFit: 'cover', boxShadow: '0 2px 24px rgba(0,0,0,0.04)' }}
              />
            </div>
          </div>
        </div>
      </div>

     
      <div className="py-5" style={{ background: '#f2f4f8' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 d-flex justify-content-center mb-4 mb-lg-0">
              <img
                src={EventsImg}
                alt="Events and entertainment auditorium"
                className="img-fluid rounded"
                style={{ maxWidth: '80%', height: 'auto', objectFit: 'cover', boxShadow: '0 2px 24px rgba(0,0,0,0.04)' }}
              />
            </div>
            <div className="col-lg-7">
              <div className="mb-3">
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  background: '#fff',
                  border: '1.5px solid #bfc8d6',
                  borderRadius: '2em',
                  padding: '0.25em 1.2em 0.25em 0.9em',
                  fontSize: '0.7rem',
                  fontWeight: 500,
                  letterSpacing: '0.15em',
                  color: '#222',
                  marginBottom: '0.5em',
                  gap: '0.2em',
                  marginLeft:"1rem",
                }}>
                  <span role="img" aria-label="Events" style={{ fontSize: '0.8rem', marginLeft:"1rem", }}>🤝</span>
                  EVENTS & ENTERTAINMENT
                </span>
              </div>
              <h1 className="fw-bold mb-2" style={{ fontSize: '1.5rem', lineHeight: 1.13, color: '#111', marginLeft:"1rem", }}>
                Celebrations matter.
              </h1>
              <h3 className="fw-semibold mb-3" style={{ color: '#555', fontSize: '1.1rem', lineHeight: 1.2,  marginLeft:"1rem", }}>
                Even from miles away.
              </h3>
              <p className="text-muted" style={{ maxWidth: '650px', fontSize: '0.9rem', lineHeight: 1.7, marginTop: "10px",  marginLeft:"1rem", }}>
                Whether it’s a destination wedding, family function, or corporate event, we plan and execute every detail to perfection. From planning to execution, we make your moments magical, no matter where you are in the world. You bring the dream. We bring it to life – beautifully.
              </p>
            </div>
          </div>
        </div>
      </div>

     

      {/* Immigration Section
      <div className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 mb-4 mb-lg-0 ">
              <div className="mb-3">
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  background: '#fff',
                  border: '1.5px solid #bfc8d6',
                  borderRadius: '2em',
                  padding: '0.25em 1.2em 0.25em 0.9em',
                  fontSize: '0.7rem',
                  fontWeight: 500,
                  letterSpacing: '0.15em',
                  color: '#222',
                  marginBottom: '0.5em',
                  gap: '0.2em',
                  marginLeft:"1rem",
                }}>
                  <span role="img" aria-label="Immigration" style={{ fontSize: '0.8rem',  marginLeft:"1rem", }}>🤝</span>
                  IMMIGRATION
                </span>
              </div>
              <h1 className="fw-bold mb-2" style={{ fontSize: '1.5rem', lineHeight: 1.13, color: '#111', marginLeft:"1rem", }}>
                Starting a new chapter abroad.
              </h1>
              <h3 className="fw-semibold mb-3" style={{ color: '#555', fontSize: '1.1rem', lineHeight: 1.2, marginLeft:"1rem", }}>
                Let's make it smooth.
              </h3>
              <p className="text-muted" style={{ maxWidth: '650px', fontSize: '0.9rem', lineHeight: 1.7, marginTop: "10px", marginLeft:"1rem", }}>
                Whether you’re reuniting with family, exploring new opportunities, or settling into a new country, we help make your immigration journey stress-free. From paperwork to legal clarity, our experienced team handles every detail with care – so you can move forward with confidence.
              </p>
            </div>
            <div className="col-lg-5 d-flex justify-content-center">
              <img
                src={ImmigrationImg}
                alt="Immigration passport and plane"
                className="img-fluid rounded"
                style={{ maxWidth: '80%', height: 'auto', objectFit: 'cover', boxShadow: '0 2px 24px rgba(0,0,0,0.04)' }}
              />
            </div>
          </div>
        </div>
      </div> */}

      
      {/* Security Section */}
         <div className="py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="mb-3">
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  background: '#fff',
                  border: '1.5px solid #bfc8d6',
                  borderRadius: '2em',
                  padding: '0.25em 1.2em 0.25em 0.9em',
                  fontSize: '0.7rem',
                  fontWeight: 500,
                  letterSpacing: '0.15em',
                  color: '#222',
                  marginBottom: '0.5em',
                  gap: '0.2em',
                  marginLeft:"1rem",
                }}>
                  <span role="img" aria-label="Security" style={{ fontSize: '0.8em', marginLeft:"1rem", }}>🤝</span>
                  SECURITY
                </span>
              </div>
              <h1 className="fw-bold mb-2" style={{ fontSize: '1.4rem', lineHeight: 1.13, color: '#111', marginLeft:"1rem", }}>
                Stay secure about what’s happening.
              </h1>
              <h3 className="fw-semibold mb-3" style={{ color: '#555', fontSize: '1.1rem', lineHeight: 1.2 ,  marginLeft:"1rem",}}>
                Back home while you are away.
              </h3>
              <p className="text-muted" style={{ maxWidth: '650px', fontSize: '0.9rem', lineHeight: 1.7, marginTop: "10px", marginLeft:"1rem", }}>
                We get it. That’s why we offer dedicated security services designed just for NRIs – so your home, family, and property in India are looked after around the clock. Whether it’s regular monitoring, emergency alerts, or property protection, our team stays vigilant so you can feel safe and stay focused on your life abroad. Peace of mind isn’t a luxury – it’s a right. And we’re here to protect it.
              </p>
            </div>

            <div className="col-lg-5 d-flex justify-content-center mb-4 mb-lg-0">
              <img
                src={SecurityImg}
                alt="Security family"
                className="img-fluid rounded"
                style={{ maxWidth: '80%', height: 'auto', objectFit: 'cover', boxShadow: '0 2px 24px rgba(0,0,0,0.04)' }}
              />
            </div>
          </div>
        </div>
      </div>

      

      {/* Documentation Section */}
      <div className="py-5" style={{ background: '#f2f4f8' }}>
        <div className="container">
          <div className="row align-items-center">            
            <div className="col-lg-5 d-flex justify-content-center">
              <img
                src={DocumentationImg}
                alt="Documentation files and folders"
                className="img-fluid rounded"
                style={{ maxWidth: '80%', height: 'auto', objectFit: 'cover', boxShadow: '0 2px 24px rgba(0,0,0,0.04)' }}
              />
            </div>

            <div className="col-lg-7 mb-4 mb-lg-0 ">
              <div className="mb-3">
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  background: '#fff',
                  border: '1.5px solid #bfc8d6',
                  borderRadius: '2em',
                  padding: '0.25em 1.2em 0.25em 0.9em',
                  fontSize: '0.7rem',
                  fontWeight: 500,
                  letterSpacing: '0.15em',
                  color: '#222',
                  marginBottom: '0.5em',
                  gap: '0.2em',
                  marginLeft:"1rem",
                }}>
                  <span role="img" aria-label="Documentation" style={{ fontSize: '0.8em' }}>🤝</span>
                  DOCUMENTATION
                </span>
              </div>
              <h1 className="fw-bold mb-2" style={{ fontSize: '1.5rem', lineHeight: 1.13, color: '#111', marginLeft:"1rem", }}>
                All the paperwork sorted –
              </h1>
              <h3 className="fw-semibold mb-3" style={{ color: '#555', fontSize: '1.1rem', lineHeight: 1.2, marginLeft:"1rem", }}>
                Fast and accurately.
              </h3>
              <p className="text-muted" style={{ maxWidth: '650px', fontSize: '0.9rem', lineHeight: 1.7, marginTop: "10px", marginLeft:"1rem", }}>
                We understand how crucial the right documents are – for legal cases, business, or personal matters. Our team makes sure you have what you need, when you need it, with no last-minute surprises. You focus on what matters – we’ll handle the paperwork.
              </p>
            </div>
          </div>
        </div>
      </div>



      <div className="py-5" style={{ background: '#fff' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="mb-3">
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  background: '#fff',
                  border: '1.5px solid #bfc8d6',
                  borderRadius: '2em',
                  padding: '0.25em 1.2em 0.25em 0.9em',
                  fontSize: '0.7rem',
                  fontWeight: 500,
                  letterSpacing: '0.15em',
                  color: '#222',
                  marginBottom: '0.5em',
                  gap: '0.2em',
                  marginLeft:"1rem",
                }}>
                  <span role="img" aria-label="Security" style={{ fontSize: '0.8em', marginLeft:"1rem", }}>🤝</span>
                   LEGAL
                </span>
              </div>
              <h1 className="fw-bold mb-2" style={{ fontSize: '1.4rem', lineHeight: 1.13, color: '#111', marginLeft:"1rem", }}>
                 Legal matters can feel overwhelming.
              </h1>
              <h3 className="fw-semibold mb-3" style={{ color: '#555', fontSize: '1.1rem', lineHeight: 1.2 ,  marginLeft:"1rem",}}>
                  But you don’t have to face them alone.
              </h3>
              <p className="text-muted" style={{ maxWidth: '650px', fontSize: '0.9rem', lineHeight: 1.7, marginTop: "10px", marginLeft:"1rem", }}>
                 Whether it’s a civil issue, a property dispute, or something more complex, our legal experts work closely with you to find the right solution, represent your interests, and resolve issues efficiently. We fight for what’s fair — so you can focus on your life abroad.
              </p>
            </div>

            <div className="col-lg-5 d-flex justify-content-center mb-4 mb-lg-0">
              <img
                src={SecurityImg}
                alt="Security family"
                className="img-fluid rounded"
                style={{ maxWidth: '80%', height: 'auto', objectFit: 'cover', boxShadow: '0 2px 24px rgba(0,0,0,0.04)' }}
              />
            </div>
          </div>
        </div>
      </div>


      
      
      
      {/* Legal Section */}
      {/* <div className="py-5" style={{ background: '#fff' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 mb-4 mb-lg-0 ">
              <div className="mb-3">
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  background: '#fff',
                  border: '1.5px solid #bfc8d6',
                  borderRadius: '2em',
                  padding: '0.25em 1.2em 0.25em 0.9em',
                  fontSize: '0.7rem',
                  fontWeight: 500,
                  letterSpacing: '0.15em',
                  color: '#222',
                  marginBottom: '0.5em',
                  gap: '0.2em',
                  marginLeft:"1rem",
                }}>
                  <span role="img" aria-label="Legal" style={{ fontSize: '0.8rem' }}>🤝</span>
                  LEGAL
                </span>
              </div>
              <h1 className="fw-bold mb-2" style={{ fontSize: '1.5rem', lineHeight: 1.13, color: '#111', marginLeft:"1rem", }}>
                Legal matters can feel overwhelming
              </h1>
              <h3 className="fw-semibold mb-3" style={{ color: '#555', fontSize: '1.1rem', lineHeight: 1.2, marginLeft:"1rem", }}>
                But You Don’t Have To Face Them Alone.
              </h3>
              <p className="text-muted" style={{ maxWidth: '650px', fontSize: '0.9rem', lineHeight: 1.7, marginTop: "10px", marginLeft:"1rem", }}>
                Whether it’s a civil issue, a property dispute, or something more complex, our legal experts work closely with you to find the right solution, represent your interests, and resolve issues efficiently. We fight for what’s fair — so you can focus on your life abroad.
              </p>
            </div>
            <div className="col-lg-5 d-flex justify-content-center">
              <img
                src={LegalImg}
                alt="Legal gavel and scales"
                className="img-fluid rounded"
                style={{ maxWidth: '80%', height: 'auto', objectFit: 'cover', boxShadow: '0 2px 24px rgba(0,0,0,0.04)' }}
              />
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default MainServices;